import AdminDashboard from "../components/admin/AdminDashboard";
import DropdownAdmin from "../components/admin/DropdownAdmin";
import RatingComponent from "../components/rating/RatingComponent";
import ReclamationForm from "../pages/create-declaration/ReclamationForm";
import FaqPage from "../pages/faq-page/FaqPage";
import HomePage from "../pages/home-page/HomePage"
import TrackingSystem from "../pages/track-declaration/TrackingSystem";


const routes = [
  {
    path: '/',
    name: 'Homreclamatione',
    element: <HomePage />
  },
  {
    path: '/create-reclamation',
    name: 'Creation de réclamation',
    element: <ReclamationForm />
  },
  {
    path: '/tracking',
    name: 'Suivie de réclamation',
    element: <TrackingSystem />
  },
  {
    path: 'rating/:trackingNumber',
    name: 'Rating',
    element: <RatingComponent />
  },
  {
    path: 'tracking/:trackingNumber',
    name: 'Suivi',
    element: <TrackingSystem />
  },
  {
    path: '/faq',
    name: 'FAQ',
    element: <FaqPage />
  },

];

export default routes;
